
import moment from 'moment'

//filter state
const filterReducerDefaultState = {
    text: '',
    sortBy: '',
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
}
export const filterReducer = (state = filterReducerDefaultState, action) => {
    switch (action.type) {

        case  'SET_TEXT_FILTER' :
            return {
                ...state,
                text : action.text
            }
        case  'SORT_BY_AMOUNT' :
            return {
                ...state,
                sortBy : 'amount'
            }
        case  'SORT_BY_DATE' :
            return {
                ...state,
                sortBy : 'date'
            }
        case  'SET_END_DATE' :
            return {
                ...state,
                endDate : action.endDate
            }
        case  'SET_START_DATE' :
            return {
                ...state,
                startDate : action.startDate
            }
        default: return state
    }
}
